module.exports = __webpack_public_path__ + "img/news-banner.580bfbe4.jpg";